import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { OrderModule } from './order.module';
platformBrowserDynamic().bootstrapModule(OrderModule);
